/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Tampilan_S1Inputs */

const en_tut_tampilan_s1 = /** @type {(inputs: Tut_Tampilan_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open **Settings → Tampilan**, or use the avatar menu in the top right.`)
};

const id_tut_tampilan_s1 = /** @type {(inputs: Tut_Tampilan_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka **Settings → Tampilan**, atau lewat menu avatar di kanan atas.`)
};

/**
* | output |
* | --- |
* | "Open **Settings → Tampilan**, or use the avatar menu in the top right." |
*
* @param {Tut_Tampilan_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_tampilan_s1 = /** @type {((inputs?: Tut_Tampilan_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Tampilan_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_tampilan_s1(inputs)
	return en_tut_tampilan_s1(inputs)
});